import { Actions, ActionTypes } from '@appStore/products/actions';
import { ProductCategory, Fi2XmlOrderForm } from '@model';
import { ProductInformationTexts } from 'app/models/product-information-texts.model';

export interface State {
  loading: boolean;
  loaded: boolean;
  data: ProductCategory[];
  texts: ProductInformationTexts;
  fi2XmlPurchased: boolean;
  fi2XmlPurchaseLoaded: boolean;
  fi2XmlPurchaseLoading: boolean;
  registeredOnCustomer: Fi2XmlOrderForm;
  registeredOnCustomerLoading: boolean;
  registeredOnCustomerLoaded: boolean;
}

export const initialState: State = {
  loading: false,
  loaded: false,
  data: null,
  texts: { groupsText: '', packagesText: '' },
  fi2XmlPurchased: false,
  fi2XmlPurchaseLoaded: false,
  fi2XmlPurchaseLoading: false,
  registeredOnCustomer: null,
  registeredOnCustomerLoading: false,
  registeredOnCustomerLoaded: false,
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.ProductsLoad:
      return { ...state, loaded: false, loading: true };

    case ActionTypes.ProductsLoadSuccess:
      return {
        ...state,
        loaded: true,
        loading: false,
        data: action.payload.productCategories,
        texts: { packagesText: action.payload.packagesText, groupsText: action.payload.groupsText }
      };

    case ActionTypes.ProductsLoadFail:
      return { ...state, loaded: false, loading: false };


    case ActionTypes.PurchaseFi2Xml:
      return { ...state, fi2XmlPurchaseLoaded: false, fi2XmlPurchaseLoading: true, fi2XmlPurchased: false };
    case ActionTypes.PurchaseFi2XmlFail:
      return { ...state, fi2XmlPurchaseLoaded: false, fi2XmlPurchaseLoading: false };
    case ActionTypes.PurchaseFi2XmlSuccess:
      return { ...state, fi2XmlPurchaseLoaded: true, fi2XmlPurchaseLoading: false, fi2XmlPurchased: action.payload };

    case ActionTypes.IsFi2XmlRegisteredOnCustomer:
      return {
        ...state,
        registeredOnCustomerLoaded: false,
        registeredOnCustomerLoading: true,
        registeredOnCustomer: null
      };
    case ActionTypes.IsFi2XmlRegisteredOnCustomerFail:
      return { ...state, registeredOnCustomerLoaded: false, registeredOnCustomerLoading: false };
    case ActionTypes.IsFi2XmlRegisteredOnCustomerSuccess:
      return {
        ...state,
        registeredOnCustomerLoaded: true,
        registeredOnCustomerLoading: false,
        registeredOnCustomer: action.payload
      };
  }
  return state;
}

export const getAll = (state: State) => state.data;
export const getTexts = (state: State) => state.texts;
export const getLoaded = (state: State) => state.loaded;
export const getLoading = (state: State) => state.loading;
export const getIsRegisteredLoaded = (state: State) => state.registeredOnCustomerLoaded;
export const getIsRegistered = (state: State) => state.registeredOnCustomer;

